import styled from 'styled-components';
import Select from 'react-select';

export const StyledContainer = styled.section`
  width: 100%;
`;

export const StyledSelectContainer = styled.div`
  width: 100%;
  margin: 5px;
  > input {
    border: none;
  }
  @media screen and (max-width: 1204px) {
    flex: none;
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    max-width: inherit;
  }
`;

export const StyledSelect = styled(Select)`
  .react-select__placeholder {
    font-family: 'Archivo', sans-serif;
    font-size: 14.222px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.5px;
  color: ${({ theme }) => theme.textFaint};
  }
  .react-select__option {
    font-family: 'Archivo', sans-serif;
  }
`;

export const StyledTablePreloader = styled.div`
  background-color: ${({ theme }) => theme.card};
  border-radius: 4px;
`;
